import axios from "axios";

const tcDataEndpoint =
  process.env.REACT_APP_TC_DATA_ENDPOINT || "/gettcdata.php";

export const getStudentTCData = async (regCode = "") => {
  try {
    const response = await axios.get(tcDataEndpoint, {
      params: regCode ? { reg_code: regCode } : undefined,
    });

    return response.data?.student_tcinfo || [];
  } catch (error) {
    console.log(error);
    return [];
  }
};
